export default __webpack_public_path__ + "images/0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452.png";